"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreContractCreditAgreement = void 0;
var services_1 = require("@falcon/services");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var PreContractCreditAgreement = /** @class */ (function (_super) {
    __extends(PreContractCreditAgreement, _super);
    function PreContractCreditAgreement(props) {
        return _super.call(this, props) || this;
    }
    PreContractCreditAgreement.prototype.render = function () {
        return (React.createElement("div", { id: "preContractAgreement", className: "documents-widget " },
            React.createElement("h2", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-18" }, "Consumer Credit Agreement"),
            React.createElement("p", null, "Because you told us that you'd like to pay monthly instalments, your payments will be subject to a Consumer Credit Agreement. You can read a copy of the Agreement below, including pre-contract explanations. We'll include both of these when we send you your policy details once you've bought your insurance."),
            React.createElement("ul", { className: "list-unstyled" },
                React.createElement("li", { className: "media" },
                    React.createElement("img", { className: "mr-2 document-icon", alt: "document-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/pdf-icon.png") }),
                    React.createElement("div", { className: "media-body" },
                        React.createElement("h5", null,
                            React.createElement("a", { className: "btn-text", href: "".concat(process.env.REACT_APP_JOURNEY_SERVICE_BASE_URL, "/interactions/").concat(this.props.engine.getInteraction()._id, "/renderDocument/wolf_pre_contract_credit_info?").concat((0, commonFunctions_1.prepareQueryString)(process.env.REACT_APP_JOURNEY_SERVICE_CUSTOM_QUERY_STRING)), target: "_blank" }, "Pre-contract credit agreement")))))));
    };
    return PreContractCreditAgreement;
}(plugin_journey_1.WidgetBase));
exports.PreContractCreditAgreement = PreContractCreditAgreement;
//# sourceMappingURL=PreContractCreditAgreement.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/PreContractCreditAgreement.js
// module id = 3212
// module chunks = 0